import styled from 'styled-components';
import { motion } from 'framer-motion';

import { COLORS } from '@theme/colors';
import { media } from '@theme/media';
import { OFFSET } from '@theme/helpers';

export const Gradient = styled.div`
  height: 102px;
  width: 100%;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
`;

export const Container = styled.div`
  margin-bottom: 30px;
`;

export const ConfirmButtonWrapper = styled.div`
  margin-top: 10px;
`;

export const Button = styled.button`
  padding: 8px;
  width: 100%;
  border: 1px solid ${COLORS.BLACK};
  margin-top: ${OFFSET.S};
`;

export const Wrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 13px 26px ${OFFSET.M} 0;
  overflow: auto;
`;

export const Content = styled.div`
  padding-left: 35px;
  background-color: ${COLORS.WHITE};
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid ${COLORS.BLACK};
  padding: 14px 0 34px;
  background-color: ${COLORS.WHITE};
`;

export const CloseButton = styled.button`
  width: 12px;
  height: 12px;
  cursor: pointer;
  position: relative;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 6px;
    height: 12px;
    width: 1px;
    background-color: ${COLORS.BLACK};
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
`;

export const SpaceViewButtonWrapper = styled(motion.div)`
  display: none;

  ${media.tablet} {
    display: block;
  }
`;
